import React from 'react';
import { connect } from 'react-redux';
import { actionCreators } from '../store/UserData';
import { bindActionCreators } from 'redux';
import { ListGroupItem, Card, CardTitle,Button,Row,Col } from 'reactstrap';
import RegisteredLocations from './RegisteredLocations';
import RegisteredCancellations from './RegisteredCancellations';
import { getName, getSalutation } from './TitlePrinter';
import '../styles/ConfirmationStep.css'

class UserData extends React.Component{
  constructor(props) {
    super(props);

    this.handleRegistrationRemoval = this.handleRegistrationRemoval.bind(this);
    this.handleCancellationRemoval = this.handleCancellationRemoval.bind(this);
    this.jumpToFirstStep = this.jumpToFirstStep.bind(this);
    this.jumpToSecondStep = this.jumpToSecondStep.bind(this);
  }

  handleRegistrationRemoval(event){
    if(this.props.LocationRegistrations.length <= 1){
      document.getElementById("limitInfo").innerText = "Es muss mindestens eine Eingabe geben! Gehen Sie einen Schritt zurück um Änderungen vorzunehmen.";
      return;
    }
    const reg = this.props.LocationRegistrations.filter(reg => reg.meternumber === event.currentTarget.id)[0]

    const indexOfElement = this.props.LocationRegistrations.indexOf(reg);
    this.props.removeRegistration(indexOfElement);
  }

  handleCancellationRemoval(event){
    if(this.props.LocationCancellations.length <= 1){
      document.getElementById("limitInfo").innerText = "Es muss mindestens eine Eingabe geben! Gehen Sie einen Schritt zurück um Änderungen vorzunehmen.";
      return;
    }
    const reg = this.props.LocationCancellations.filter(reg => reg.meternumber === event.currentTarget.id)[0]

    const indexOfElement = this.props.LocationCancellations.indexOf(reg);
    this.props.removeCancellation(indexOfElement);
  }
  jumpToFirstStep(event) {
    this.props.steps.jumpToStep(0);
  }
  jumpToSecondStep(event) {
    this.props.steps.jumpToStep(1);
  }

  render(){
    let admin = this.props.Administration;
    let registrations = this.props.LocationRegistrations;
    let cancellations = this.props.LocationCancellations;
    let SummaryOptionAdmin;
    let SummaryConsumption;
    if (this.props.isSummary) {
      SummaryOptionAdmin=  <Button id="summaryButton" color="link" onClick={this.jumpToFirstStep} > > Eingaben korrigieren</Button>
      SummaryConsumption=  <Button id="summaryButton" color="link" onClick={this.jumpToSecondStep} > > Eingaben korrigieren</Button>
    }

    return(
      <div>
      <Card id="firstCard"className="p-2">
      <Row>
        <Col>
        <CardTitle id="first">
          Verwaltung
        </CardTitle>
        </Col>
        <Col></Col>
        <Col></Col>
        <Col>
        {SummaryOptionAdmin}
        </Col>
      </Row>
              <ListGroupItem id="li">Anrede: {getSalutation(admin.salutation)}</ListGroupItem>
              <ListGroupItem id="li">Name: {getName(admin)} </ListGroupItem>
              <ListGroupItem id="li">Straße: {admin.street} {admin.housenumber}{admin.housenumberextension}</ListGroupItem>
              <ListGroupItem id="li">Postleitzahl: {admin.postcode} {admin.city}</ListGroupItem>
      </Card>
      <Card id="secondCard" className="p-2">
        <Row>
          <Col>
          <CardTitle id="second" >
            Verbrauchsstelle
          </CardTitle>
          </Col>
          <Col></Col>
          <Col></Col>
          <Col>
            {SummaryConsumption}
          </Col>
        </Row>
        <RegisteredLocations LocationRegistrations={registrations} HandleRegistrationRemoval={this.handleRegistrationRemoval.bind(this)} />
        <RegisteredCancellations LocationCancellations={cancellations} HandleCancellationRemoval={this.handleCancellationRemoval} />
      </Card>
      </div>
    )
  }
};

export default connect(
  state => state.userData,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(UserData);



// WEBPACK FOOTER //
// ./src/components/UserData.js